import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  resourceRolResponsible (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}resourceNotification/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchStatus () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}fetchStatusNotification`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  changeDateTask (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}dateTaskNotification/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchResponsibleStatus (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}fetchResponsibleStatus/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateResponsibleStatus (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}updateResponsibleStatus/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateFranchisesStatus (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}updateFranchisesStatus/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateResponsibleEmail (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}updateResponsibleEmail/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
